export default __webpack_public_path__ + "static/media/doctorsChamber.cfc7f86b.jpg";